// extracted by mini-css-extract-plugin
module.exports =  {"customCol":"customCol__4dFQi"};